import React, { useContext, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Alert, Box, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import KeyRoundedIcon from "@mui/icons-material/KeyRounded";
import { api } from "../api/axios";
import { AuthContext } from "../contexts/AuthContext";
import { IconTile } from "../components/ui";
import { AuthShell } from "./marketing/MarketingParts";
import { PasswordField } from "./marketing/AuthFields";

export default function SetPassword() {
  const { t } = useTranslation();
  const loc = useLocation();
  const nav = useNavigate();
  const { verify } = useContext(AuthContext);
  const token = useMemo(() => new URLSearchParams(loc.search).get("token") || "", [loc.search]);

  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const { data } = await api.post("/api/users/reset-password", { token, password });
      if (data?.token) localStorage.setItem("aw_token", data.token);
      await verify();
      setDone(true);
      setTimeout(() => nav("/sites"), 700);
    } catch (err) {
      setError(err?.response?.data?.message || t("mka_err"));
    }
  };

  return (
    <AuthShell
      title={t("mka_set_title")}
      subtitle={t("mka_set_sub")}
      icon={
        <IconTile size={48}>
          <KeyRoundedIcon />
        </IconTile>
      }
    >
      <Box aria-live="polite" sx={{ display: "grid", gap: 2, mb: !token || done ? 2 : 0 }}>
        {!token ? <Alert severity="error">{t("mka_set_missing")}</Alert> : null}
        {done ? <Alert severity="success">{t("mka_set_done")}</Alert> : null}
      </Box>
      {!done ? (
        <Box component="form" onSubmit={onSubmit} sx={{ display: "grid", gap: 2 }}>
          {error ? <Alert severity="error">{error}</Alert> : null}
          <PasswordField label={t("mka_set_new")} value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="new-password" />
          <Button type="submit" variant="contained" size="large" fullWidth disabled={!token}>
            {t("mka_set_btn")}
          </Button>
        </Box>
      ) : null}
    </AuthShell>
  );
}
